export const SET_SNACK_MESSAGE = 'SET_SNACK_MESSAGE'
export const SET_FILTERS = 'SET_FILTERS'
export const SET_HEADER_HEIGHT = 'SET_HEADER_HEIGHT'
export const RESET_STEPS_FILLING = 'RESET_STEPS_FILLING'
export const SET_STEP_FILLED = 'SET_STEP_FILLED'
export const SET_FILTER_ROW_SHOWN_STATE = 'SET_FILTER_ROW_SHOWN_STATE'
export const UPDATE_INIT_COUNT = 'UPDATE_INIT_COUNT'
